module.exports = __webpack_public_path__ + "static/media/super_pack_128x128.eb7fc2f2.png";